import { sessionStorageKeys } from '../utils/common'

class SaveLayout {
  data = {}

  add = (key, value) => {
    const currentData =
      JSON.parse(sessionStorage.getItem(sessionStorageKeys.KEY_SAVE_LAYOUT)) ||
      {}

    sessionStorage.setItem(
      sessionStorageKeys.KEY_SAVE_LAYOUT,
      JSON.stringify({
        ...currentData,
        [key]: value,
      }),
    )
  }

  get = (key) => {
    const currentData =
      JSON.parse(sessionStorage.getItem(sessionStorageKeys.KEY_SAVE_LAYOUT)) ||
      {}

    return currentData[key]
  }
}

const saveLayout = new SaveLayout()
export default saveLayout
